import type { LabelHTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export function Label({ className, children, ...rest }: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label className={cn('text-base font-medium text-text-primary', className)} {...rest}>
      {children}
    </label>
  );
}

export function HelperText({ className, children }: { className?: string; children: ReactNode }) {
  return <p className={cn('text-sm text-text-secondary', className)}>{children}</p>;
}

export function ErrorText({ id, className, children }: { id?: string; className?: string; children: ReactNode }) {
  return (
    <p id={id} role="alert" className={cn('text-sm text-danger flex items-start gap-1.5', className)}>
      {children}
    </p>
  );
}
